import React__default from 'react';
var ModalContext = React__default.createContext({});
var useModalContext = function useModalContext() {
  return React__default.useContext(ModalContext);
};
export { ModalContext, useModalContext };